import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { PROFILE } from "../data";
import { WindowsLogo } from "./Taskbar";
import "./Screens.css";

export function BootScreen() {
  return (
    <div className="boot" role="status" aria-label="Starting">
      <div className="boot__logo">
        <WindowsLogo size={72} />
      </div>
      <div className="boot__spinner" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span key={i} style={{ animationDelay: `${i * 0.14}s` }} />
        ))}
      </div>
    </div>
  );
}

export function LockScreen({ onUnlock }) {
  const [now, setNow] = useState(() => new Date());
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000 * 15);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const go = () => setSigningIn(true);
    window.addEventListener("keydown", go);
    return () => window.removeEventListener("keydown", go);
  }, []);

  useEffect(() => {
    if (!signingIn) return;
    const id = setTimeout(onUnlock, 900);
    return () => clearTimeout(id);
  }, [signingIn, onUnlock]);

  return (
    <div
      className={`lock ${signingIn ? "lock--in" : ""}`}
      onClick={() => setSigningIn(true)}
      role="button"
      tabIndex={0}
      aria-label="Unlock and enter the portfolio"
    >
      <div className="lock__wallpaper" aria-hidden="true">
        <span className="bloom bloom--1" />
        <span className="bloom bloom--2" />
        <span className="bloom bloom--3" />
      </div>

      <div className="lock__clock">
        <div className="lock__time">
          {now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </div>
        <div className="lock__date">
          {now.toLocaleDateString([], {
            weekday: "long",
            month: "long",
            day: "numeric",
          })}
        </div>
      </div>

      <div className="lock__user">
        <img className="lock__avatar" src={PROFILE.avatar} alt="" />
        <h1 className="lock__name">{PROFILE.name}</h1>
        <p className="lock__role">
          {PROFILE.role} · {PROFILE.location}
        </p>
        <span className="lock__cta">
          {signingIn ? "Welcome" : "Click anywhere to sign in"}
          {!signingIn && <ChevronRight size={15} />}
        </span>
      </div>
    </div>
  );
}
